import { PayloadAction } from "@reduxjs/toolkit";
import { INotificationDeviceFilterState } from "../types";
import { IGeoRegion, INotificationGrpData } from "../../api/admin/types";
import { initialGeoRegion } from "../../../components/helpers";

export const setGroupKeyAction = (state: INotificationDeviceFilterState, action: PayloadAction<INotificationGrpData>) => {
  state.groupKey = action.payload;
};

export const setIsNotificationDeviceAssociationProgressAction = (state: INotificationDeviceFilterState, action: PayloadAction<boolean>) => {
  state.isNotificationDeviceAssociationProgress = action.payload;
};

export const setSiteGroupAction = (state: INotificationDeviceFilterState, action: PayloadAction<string>) => {
  state.siteGroup = action.payload;
};

export const setAddDeviceSiteGroupAction = (state: INotificationDeviceFilterState, action: PayloadAction<string>) => {
  state.addDeviceSiteGroup = action.payload;
};

export const setGeoRegionAction = (state: INotificationDeviceFilterState, action: PayloadAction<IGeoRegion>) => {
  state.geoRegion = action.payload;
};

export const setAddDeviceGeoRegionAction = (state: INotificationDeviceFilterState, action: PayloadAction<IGeoRegion>) => {
  state.addDeviceGeoRegion = action.payload;
};

export const setIsAssociatedDevicesRemovedAction = (state: INotificationDeviceFilterState, action: PayloadAction<boolean>) => {
  state.isAssociatedDevicesRemoved = action.payload;
};

export const resetFiltersAction = (state: INotificationDeviceFilterState) => {
  state.geoRegion = initialGeoRegion;
  state.siteGroup = "";
};

export const resetAddDeviceFiltersAction = (state: INotificationDeviceFilterState) => {
  state.addDeviceGeoRegion = initialGeoRegion;
  state.addDeviceSiteGroup = "";
};